import { render } from "./FontsidevueNav.vue?vue&type=template&id=535df9ed&scoped=true"
import script from "./FontsidevueNav.vue?vue&type=script&lang=js"
export * from "./FontsidevueNav.vue?vue&type=script&lang=js"

import "./FontsidevueNav.vue?vue&type=style&index=0&id=535df9ed&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535df9ed"]])

export default __exports__